import React from "react"
import { RadioBox } from "./helper";
import { Translate } from "react-localize-redux";

const ans = [
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
]
export class VerticalVision extends RadioBox {
    constructor(props) {
        super(props, props.setState)
    }
	render() {
		return (
			<Translate key={this.props.template.id}>
				{({ translate }) => 
					<tr>
						<td colSpan="2">
							7. {this.props.template.name}
						</td>
                        {
                            ans.map((x, index) => 
                                <td
                                    key={index}
                                    colSpan="2"
                                    className={`
                                        ${x < (this.props.limit.lower_limit??3) ? "highlight": ''}
                                        ${x > (this.props.limit.upper_limit??5) ? "highlight": ''}
                                    `.trim()}
                                >
                                    <label
                                        className={this.state.value === x ? 'active': ''}
                                    >
                                        <input
                                            name="vertical-vision"
                                            type="radio"
                                            value={x}
                                            onChange={(e) => this.onChangeHandler(e)}
                                            onClick={e => this.onClickHandler(e)}
                                            checked={this.state.value === x}
                                        />
                                        {x}
                                    </label>
                                </td>
                            )
                        }
                        <td></td>
					</tr>
				}
			</Translate>
		)
	}
}